export var NotificationTypes;
(function (NotificationTypes) {
    NotificationTypes["INFO"] = "info";
    NotificationTypes["WARNING"] = "warning";
    NotificationTypes["ERROR"] = "error";
    NotificationTypes["SUCCESS"] = "success";
})(NotificationTypes || (NotificationTypes = {}));
